import { provide, inject, type InjectionKey } from 'vue'
import type { HistoryListItem } from '@/utils/format-edit/historyList'

export type NewRirekishoExampleSentence = {
  title: string
  description: string
}

export type NewRirekishoExampleSentences = {
  license?: NewRirekishoExampleSentence[]
  reason?: NewRirekishoExampleSentence[]
  request?: NewRirekishoExampleSentence[]
}

export type NewRirekishoFormatData = {
  createDate: Date | null
  writeDate?: string
  educationalHistories: HistoryListItem[]
  jobHistories: HistoryListItem[]
  licenseHistories: HistoryListItem[]
  commuteDescription: string
  commuteHours: string
  commuteMinutes: string
  spouseNumber: string
  hasSpouse: boolean | null
  underDutyToSupport: boolean | null
  reason: string
  reasonNew: string
  request: string
  nowNensyu: string
  kibouNensyu: string
  notDisplayRecommend: boolean
  notDisplayIjyo?: boolean
  gradeYear?: string
  department?: string
  hopeAreaPref?: string
  hopeIndustry?: string
  hopeJobcategory?: string
  foreignStudent?: boolean
  registYagioffer?: boolean
  campus_history_content?: string
  campus_history_summary?: string
  gakuchika_content?: string
  gakuchika_summary?: string
} & Record<string, unknown>

const NEW_RIREKISHO_FORMAT_DATA_KEY: InjectionKey<NewRirekishoFormatData> =
  Symbol('newRirekishoFormatData')

export function createEmptyNewRirekishoFormatData(): NewRirekishoFormatData {
  return {
    createDate: null,
    educationalHistories: [],
    jobHistories: [],
    licenseHistories: [],
    commuteDescription: '',
    commuteHours: '',
    commuteMinutes: '',
    spouseNumber: '',
    hasSpouse: null,
    underDutyToSupport: null,
    reason: '',
    reasonNew: '',
    request: '',
    nowNensyu: '',
    kibouNensyu: '',
    notDisplayRecommend: true,
    notDisplayIjyo: false,
    gradeYear: '',
    department: '',
    hopeAreaPref: '',
    hopeIndustry: '',
    hopeJobcategory: '',
    foreignStudent: false,
    registYagioffer: true,
    campus_history_content: '',
    campus_history_summary: '',
    gakuchika_content: '',
    gakuchika_summary: ''
  }
}

export function provideNewRirekishoFormatData(
  formatData: NewRirekishoFormatData
) {
  provide(NEW_RIREKISHO_FORMAT_DATA_KEY, formatData)
}

export function useNewRirekishoFormatData(): NewRirekishoFormatData {
  const formatData = inject(NEW_RIREKISHO_FORMAT_DATA_KEY)
  if (!formatData) {
    throw new Error(
      'useNewRirekishoFormatData() must be used under NewRirekishoEdit'
    )
  }
  return formatData
}
